import { warn } from "@swivl-mono/helpers";
import { RoleInterfaceMap } from "@swivl-mono/types";
import { Button } from "@swivl-mono/ui";
import * as React from "react";

import EscalationsModel from "../../../Models/Escalations/Escalations.Model";
import { Member } from "../../../Models/Member/Member.Current";
import { QuestsModel } from "../../../Models/Quests/Quests.Model";
import RolesModel from "../../../Models/Roles/Roles.Model";
import "./EscalationsView.scss";
import EscalationGroupView from "./Groups/EscalationGroupView";
import { ParentEscalationGroupView } from "./Groups/ParentEscalationGroupView";

export default function EscalationsView() {
  const { escalationGroups } = EscalationsModel.useState((s) => s);
  const { roles, defaultRoles, parentRoles } = RolesModel.useState((s) => s);
  const journeys = QuestsModel.useState((s) => s.journeys);
  const [isAddingGroup, setIsAddingGroup] = React.useState(false);
  const [slackConversations, setSlackConversations] = React.useState(null);
  const [agents, setAgents] = React.useState(null);
  React.useEffect(() => {
    EscalationsModel.loadGroups();
    QuestsModel.loadQuestsList(false);
  }, []);

  const allRoles = React.useMemo(() => {
    let all: RoleInterfaceMap = {};
    if (defaultRoles) {
      all = { ...all, ...defaultRoles };
    }
    if (parentRoles) {
      all = { ...all, ...parentRoles };
    }
    if (roles) {
      all = { ...all, ...roles };
    }
    return all;
  }, [roles, defaultRoles, parentRoles]);

  if (!escalationGroups || !journeys) {
    return null;
  }

  const groupViews = escalationGroups
    ? escalationGroups.map((item) => {
        if (Member.orgId !== item.orgId) {
          return <ParentEscalationGroupView key={item.id} group={item} />;
        }

        return <EscalationGroupView key={item.id} group={item} slackConversations={slackConversations} agents={agents} roles={allRoles} />;
      })
    : null;

  const createNewGroupClicked = () => {
    setIsAddingGroup(true);
    EscalationsModel.createGroup()
      .catch((e) => {
        warn("Error creating group", e);
      })
      .finally(() => {
        setIsAddingGroup(false);
      });
  };

  return (
    <div className="EscalationsSettingsView">
      {groupViews}
      <Button onClick={createNewGroupClicked} loading={isAddingGroup}>
        + Add Group
      </Button>
    </div>
  );
}
